import React, { FC } from 'react';
import styled from 'styled-components';

interface RadioProps {
  checked?: boolean;
  onChange?: () => void;
  id?: string;
}

const RadioWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const StyledRadio = styled.input.attrs({ type: 'radio' })<{ checked?: boolean }>`
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => checked ? 'var(--sys-color--primary)' : 'var(--sys-color--outline)'};
  border-radius: 50%;
  background: transparent;
  outline: none;
  cursor: pointer;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &::after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--sys-color--primary);
    transform: ${({ checked }) => checked ? 'scale(1)' : 'scale(0)'};
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    border-color: var(--sys-color--primary);
  }
`;

export const Radio: FC<RadioProps> = ({ checked, onChange, id }) => {
  return (
    <RadioWrapper onClick={onChange}>
      <StyledRadio id={id} checked={checked} readOnly />
    </RadioWrapper>
  );
};

export default Radio;
